module.exports = __webpack_public_path__ + "b738d7c8b41f507c17c1e31d7f517fc5.png";